import React from "react";

const certifications = [
  {
    image: "/images/certifications/wosb-certified.png",
    alt: "Woman-Owned Small Business Certified",
  },
  {
    image: "/images/certifications/sdvosb-certified.png",
    alt: "Service-Disabled Veteran-Owned Small Business Certified",
  },
  {
    image: "/images/certifications/veteran-owned-certified.png",
    alt: "Veteran-Owned Certified",
  },
  {
    image: "/images/certifications/edwosb-certified.png",
    alt: "Economically Disadvantaged Woman-Owned Small Business Certified",
  },
];

const CertificationsBar = () => {
  return (
    <section id="certifications" className="py-10 md:py-12 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6">
          <span className="inline-block px-4 py-1 bg-[#C5A047]/10 text-[#C5A047] text-sm font-semibold rounded-full mb-3">
            CERTIFICATIONS
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#2C3E50] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            SBA & Federal Certifications
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 items-center">
          {certifications.map((cert, index) => (
            <div
              key={index}
              className="flex justify-center items-center"
            >
              <img
                src={cert.image}
                alt={cert.alt}
                className="h-20 md:h-24 lg:h-28 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CertificationsBar;